import type { FC, ComponentType } from 'react';
import React from 'react';

import type { EditorActions } from '@atlaskit/editor-core';
import { WithEditorActions, WithHelpTrigger } from '@atlaskit/editor-core';
import { EditorContext } from '@atlaskit/editor-core/editor-context';

type WithEditorActionsProps = {
	editorActions: EditorActions;
	WithHelpTrigger: any;
};

export function withEditorActions<T>(
	WrappedComponent: ComponentType<T>,
): FC<Omit<T, keyof WithEditorActionsProps>> {
	function withEditorActions(props) {
		return (
			<EditorContext>
				<WithEditorActions
					render={(editorActions: EditorActions) => (
						<WrappedComponent
							editorActions={editorActions}
							WithHelpTrigger={WithHelpTrigger}
							{...props}
						/>
					)}
				/>
			</EditorContext>
		);
	}
	return withEditorActions;
}
